import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import type { AdvertiserActivityParamsDefinition } from "single-spa/react-app/config/solutions25/adIntelligence/advertiserActivity/advertiserActivityRoutes.types";
import { displayAdvertisingParamsDefinition } from "single-spa/react-app/config/solutions25/adIntelligence/displayAdvertising/displayAdvertisingConstants";
import type {
    DisplayAdvertisingParamKeys,
    DisplayAdvertisingParamsDefinition,
} from "single-spa/react-app/config/solutions25/adIntelligence/displayAdvertising/displayAdvertisingRoutes.types";
import { StateParamsConfig } from "single-spa/react-app/router/utils/state-params-build/params-config";

export const displayAdvertisingParams = new StateParamsConfig<
    DisplayAdvertisingParamsDefinition,
    DisplayAdvertisingParamKeys
>(displayAdvertisingParamsDefinition);

// Route state-name objects are the cross-solution public surface and live in the shared SI
// constants module so shared consumers never deep-import this page. Re-exported here for the
// co-located states/secondary-bar files.
export {
    SI_AA_ROUTES,
    SI_DISPLAY_ROUTES,
    SI_SEARCH_ROUTES,
    SI_SOCIAL_ROUTES,
    SI_AI_ROUTES,
    SI_LLMS_ROUTES,
} from "app/common/constants/ad-intelligence-routes";

export const siAdvertiserActivityParams: AdvertiserActivityParamsDefinition = {
    key: {
        type: "string",
        dynamic: false,
    },
    duration: {
        type: "string",
        value: "28d",
    },
    webSource: {
        type: "string",
        value: devicesTypes.DESKTOP,
    },
    country: {
        type: "int",
        array: false,
        value: 840,
    },
    isWWW: {
        type: "string",
        value: "*",
    },
} as const;
